import Select from "react-select";
const SelectField = ({
  name,
  param,
  value,
  multi = false,
  onChange = () => {},
}) => {
  const options =
    typeof param.options === "string"
      ? param.options.split(",").map((p) => {
          return { value: p, label: p };
        })
      : param.options;
  return (
    <>
      <Select
        name={name}
        options={options}
        value={options.find((o) => o.value === value)}
        isMulti={param.multi ?? false}
        onChange={onChange}
      />
    </>
  );
};

export default SelectField;
